export type RenderMode = '2d' | '3d';

export function getRenderMode(): RenderMode {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('render')?.trim().toLowerCase();
  if (fromQuery === '2d' || fromQuery === '3d') return fromQuery;

  const fromEnv = import.meta.env.VITE_RENDER_MODE?.trim().toLowerCase();
  if (fromEnv === '2d' || fromEnv === '3d') return fromEnv;

  return '3d';
}
